import './promote-tablet-version.less';

const LOCAL_STORAGE_HIDDEN = 'serpPromoteTabletVersionHidden';

export default angular.module('cian.newbuild.serp.promoteTabletVersion', [])
  .directive('promoteTabletVersion', () => ({
    restrict: 'E',
    template: require('./promote-tablet-version.jade'),
    controller: [
      '$log',
      'BrowserInfo',
      'AnalyticsService',
      ($log, BrowserInfo, AnalyticsService) => {
        const ctrl = {};

        ctrl.isVisible =
          (BrowserInfo.isMobile || BrowserInfo.isTablet || window.innerWidth <= 1024) &&
          !Boolean(localStorage.getItem(LOCAL_STORAGE_HIDDEN));

        ctrl.onClick = () => {
          document.cookie = 'flavour=mobile;path=/;domain=.cian.ru';
          rememberAsHidden();
          AnalyticsService.trackCA('Change_version_popup', 'click', 'full-version');
          window.location.reload(true);
        };

        ctrl.hide = () => {
          ctrl.isVisible = false;
          rememberAsHidden();
        };

        function rememberAsHidden() {
          try {
            localStorage.setItem(LOCAL_STORAGE_HIDDEN, 'true');
          } catch (e) {
            $log.error(e);
          }
        }

        return ctrl;
      }],
    controllerAs: 'promoteTabletVersion',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/promote-tablet-version/promote-tablet-version.dir.js